/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-no-bind */
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Image, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Field, Formik } from 'formik';
import { toast } from 'react-toastify';
import { BoxForm, BoxInput, ButtonContainer, Container } from './styles';
import { PageTitle } from '../../components/PageTitle';
import { api } from '../../services/api';

export function TechnicalTeamCreate() {
  const [initialValues] = useState({
    name: '',
    text: '',
    position: '',
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [isShowHome, setIsShowHome] = useState(false);
  const [isShowHomeTwo, setIsShowHomeTwo] = useState(false);
  const [testimonialToUpload, setTestimonialToUpload] = useState();
  const [testimonialPreview, setTestimonialPreview] = useState(null);
  const [productCategories, setProductCategories] = useState(null);
  const [productCategoriesSelected, setProductCategoriesSelected] = useState(
    [],
  );

  const navigate = useNavigate();

  async function createTechnicalTeam(values) {
    setButtonLoading(true);
    try {
      const formData = new FormData();

      const { name, text, position } = values;

      if (testimonialToUpload) {
        formData.append('file', testimonialToUpload, testimonialToUpload.name);
      }

      formData.append('name', name);
      formData.append('text', text);
      formData.append('is_show_home', isShowHome);
      formData.append('is_show_home_two', isShowHomeTwo);
      formData.append('position', position);
      formData.append(
        'product_category_ids',
        productCategoriesSelected.join(','),
      );

      await api.post('/technical-team', formData);
      toast.success('Corpo técnico cadastrado com sucesso');

      setButtonLoading(false);
      navigate(-1);
    } catch (err) {
      toast.error('Erro ao cadastrar Corpo técnico');
      setButtonLoading(false);
    }
  }

  function handleTestimonialPhono(event) {
    if (event.target.files) {
      const file = event.target.files[0];
      setTestimonialToUpload(file);

      const reader = new FileReader();

      reader.onload = () => {
        setTestimonialPreview(reader.result);
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  async function loadProductCategories() {
    try {
      const response = await api.get('/products/categories');
      setProductCategories(response.data);
    } catch (error) {
      toast.error('Erro ao carregar categorias');
    }
  }

  useEffect(() => {
    loadProductCategories();
  }, []);

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="/corpo-tecnico">
          <NavLink to="/corpo-tecnico">Corpo técnico</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Criação</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle
        title="Cadastro de corpo técnico"
        description="Gerenciamento de corpo técnico"
      />

      <BoxForm>
        <Formik initialValues={initialValues} onSubmit={createTechnicalTeam}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {testimonialPreview && (
                <div>
                  <Image width={200} height={200} src={testimonialPreview} />
                </div>
              )}

              <BoxInput style={{ marginTop: 30 }}>
                <label htmlFor="photo">Foto</label>
                <input
                  id="photo"
                  type="file"
                  name="photo"
                  onChange={handleTestimonialPhono}
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="name">Nome</label>
                <Field id="name" type="text" name="name" placeholder="Nome" />
              </BoxInput>

              <BoxInput>
                <label htmlFor="position">Cargo</label>
                <Field
                  id="position"
                  type="text"
                  name="position"
                  placeholder="Cargo"
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="text">Texto</label>
                <Field name="text">
                  {({ field }) => (
                    <div>
                      <textarea {...field} value={field.value || ''} />
                    </div>
                  )}
                </Field>
              </BoxInput>

              <BoxInput>
                <label htmlFor="is_show_home">Mostrar na home 1</label>
                <Switch
                  defaultChecked
                  checked={isShowHome}
                  onChange={() => setIsShowHome(!isShowHome)}
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="is_show_home">Mostrar na home 2</label>
                <Switch
                  defaultChecked
                  checked={isShowHomeTwo}
                  onChange={() => setIsShowHomeTwo(!isShowHomeTwo)}
                />
              </BoxInput>

              <BoxInput>
                <label htmlFor="is_show_home">Categorias</label>
                <Checkbox.Group
                  onChange={(checkedValues) =>
                    setProductCategoriesSelected(checkedValues)
                  }
                >
                  {productCategories &&
                    productCategories.map((categoryItem) => (
                      <Checkbox value={categoryItem.id}>
                        {categoryItem.name}
                      </Checkbox>
                    ))}
                </Checkbox.Group>
              </BoxInput>

              <ButtonContainer>
                <Button
                  type="primary"
                  htmlType="submit"
                  size="middle"
                  loading={buttonLoading}
                >
                  Cadastrar corpo técnico
                </Button>
              </ButtonContainer>
            </form>
          )}
        </Formik>
      </BoxForm>
    </Container>
  );
}
